import React from 'react';
import { GECKO_CONSTS, GeckoBtns, GeckoDates } from '../../../../ui';
import { useDispatch } from 'react-redux';

const Events = (props) => {
  const dispatch = useDispatch();
  const { events } = props;
  return (
    <div className="contact-events-box">
      {events.map((event, i) => {
        return (
          <div className="event" key={i}>
            <p className="event-name">
              {event.title} - {event.status}
            </p>
            <div className="event-date-wrapper">
              <span className="event-date">
                {GeckoDates.toHumanDateRange(
                  event.start_datetime,
                  event.end_datetime
                )}
              </span>
            </div>
            <div className="added-to-event-date-wrapper">
              <span className="added-date">
                Added to event on{' '}
                {GeckoDates.formatDate(
                  event.added_at,
                  'Do MMM YYYY [at] hh:mm A'
                )}
              </span>
            </div>
            <GeckoBtns
              items={[
                {
                  type: GECKO_CONSTS.BTN_TYPE_DEFAULT,
                  name: 'Send RSVP',
                  handler: () =>
                    dispatch({
                      type: 'SET_RSVP_LINK',
                      payload: event.rsvp_link,
                    }),
                  size: 'sm',
                },
                {
                  type: GECKO_CONSTS.BTN_TYPE_OUTLINE_PRIMARY,
                  name: 'View Event',
                  handler: () =>
                    window.open(
                      `${process.env.REACT_APP_ENGAGE_WEB_URL}/#/event/${event.id}/overview`
                    ),
                  size: 'sm',
                },
              ]}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Events;
